export default "__VITE_ASSET__bbcdf8e6__"